import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  ValidateApplicationName,
  validateApplicationNameValidation,
} from './ValidateApplicationNameExt';

export const ValidateApplicationNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ValidateApplicationName',
    component: ValidateApplicationName,
    validation: validateApplicationNameValidation,
  }),
);